var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-layout-wrapper"},[_c('h1',[_vm._v("Layout erstellen")]),_c('LayoutForm',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('AdaButton',{staticStyle:{"width":"100%"},attrs:{"title":"Layout erstellen","icon":"icon-add","type":"fullWidthButton"},on:{"click":_vm.createLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }